var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000488281,
    y: -0.000244141,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5005 5.99976C10.5005 6.2759 10.2766 6.49976 10.0005 6.49976C9.72435 6.49976 9.50049 6.2759 9.50049 5.99976C9.50049 5.72361 9.72435 5.49976 10.0005 5.49976C10.2766 5.49976 10.5005 5.72361 10.5005 5.99976Z",
    fill: "black",
    stroke: "#2D3D95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5005 9.99976C10.5005 10.2759 10.2766 10.4998 10.0005 10.4998C9.72435 10.4998 9.50049 10.2759 9.50049 9.99976C9.50049 9.72361 9.72435 9.49976 10.0005 9.49976C10.2766 9.49976 10.5005 9.72361 10.5005 9.99976Z",
    fill: "black",
    stroke: "#2D3D95"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5005 13.9998C10.5005 14.2759 10.2766 14.4998 10.0005 14.4998C9.72435 14.4998 9.50049 14.2759 9.50049 13.9998C9.50049 13.7236 9.72435 13.4998 10.0005 13.4998C10.2766 13.4998 10.5005 13.7236 10.5005 13.9998Z",
    fill: "black",
    stroke: "#2D3D95"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteMenu);
export default __webpack_public_path__ + "static/media/white-menu.b205dace03553dcdaab8b53e97bed471.svg";
export { ForwardRef as ReactComponent };